// @flow
import type { ControlsInfo, ProviderTemplatesInfo } from './types'

export const Audience = {
  types: {
    targeting: 'targeting',
    retargeting: 'retargeting',
    product_retargeting: 'product_retargeting',
    conversions: 'conversions',
    posts_promotion: 'posts_promotion',
    leadform: 'leadform'
  },
  vk_placements: {
    default_vk_placement: 'promopost_with_button',
    promopost_without_public: 'promopost_without_public',
    promopost_with_button: 'promopost_with_button',
    promopost_without_button: 'promopost_without_button',
    promopost_with_big_image: 'promopost_with_big_image'
  },
  placement_types: {
    column: 'column',
    multi_format: 'multi_format',
    with_video: 'with_video',
    carousel: 'carousel',
    promo_post: 'promo_post'
  },
  payment_types: {
    auto: 'auto',
    cpc: 'cpc',
    cpm: 'cpm',
    cpa: 'cpa'
  }
}

export const PreviewNames = {
  vk_preview: 'vk_preview',
  tm_banner: 'tm_banner',
  multi_facebook_preview: 'multi_facebook_preview',
  instagram_preview: 'instagram_preview',
  facebook_mobile: 'facebook_mobile',
  facebook_preview: 'facebook_preview',
  tm_lenta: 'tm_lenta',
  google_preview: 'google_preview',
  google_simple: 'google_simple',
  tm_preview: 'tm_preview',
  tm_preview_multi: 'tm_preview_multi',
  vk_promopost: 'vk_promopost',
  vk_leadform: 'vk_leadform'
}

export const audienceInputsWidth = 580

export const videoProvidersSet = ['vk', 'facebook']
export const carouselProvidersSet = ['vk', 'target_mail', 'facebook']

export const segmentWithRelationsType = 'segment_with_relations'

export const ProviderTemplateNames: ProviderTemplatesInfo<string> = {
  vk_column: 'vk_column',
  vk_multi: 'vk_multi',
  vk_article: 'vk_article',
  vk_promotion: 'vk_promotion',
  vk_site: 'vk_site',
  vk_video: 'vk_video',
  vk_leadform: 'vk_leadform',
  vk_big_image: 'vk_big_image',
  vk_carousel: 'vk_carousel',
  tm_column: 'tm_column',
  tm_multi: 'tm_multi',
  tm_product: 'tm_product',
  tm_video: 'tm_video',
  tm_carousel: 'tm_carousel',
  tm_promotion: 'tm_promotion',
  fb_multi: 'fb_multi',
  fb_product: 'fb_product',
  fb_promotion: 'fb_promotion',
  fb_leadform: 'fb_leadform',
  fb_video: 'fb_video',
  fb_carousel: 'fb_carousel',
  gl_multi: 'gl_multi',
  gl_video: 'gl_video'
}

export const ControlNames: ControlsInfo<string> = {
  url: 'url',
  vkUrl: 'vkUrl',
  tmUrl: 'tmUrl',
  fbUrl: 'fbUrl',
  title: 'title',
  vkTitle: 'vkTitle',
  fbTitle: 'fbTitle',
  productTitle: 'productTitle',
  columnDescription: 'columnDescription',
  multiDescription: 'multiDescription',
  productDescription: 'productDescription',
  vkMultiDescription: 'vkMultiDescription',
  vkWithoutButtonDescription: 'vkWithoutButtonDescription',
  vkLinkTitle: 'vkLinkTitle',
  fbMultiDescription: 'fbMultiDescription',
  tmCarouselDescription: 'tmCarouselDescription',
  columnImage: 'columnImage',
  columnImageData: 'columnImageData',
  multiImage: 'multiImage',
  multiImageData: 'multiImageData',
  logoImage: 'logoImage',
  logoImageData: 'logoImageData',
  tmSmallImage: 'tmSmallImage',
  tmSmallImageData: 'tmSmallImageData',
  fbInstagramImage: 'fbInstagramImage',
  fbInstagramImageData: 'fbInstagramImageData',
  fbStoriesImage: 'fbStoriesImage',
  fbStoriesImageData: 'fbStoriesImageData',
  vkBigImage: 'vkBigImage',
  vkBigImageData: 'vkBigImageData',
  vkColumnCrop: 'vkColumnCrop',
  vkMultiCrop: 'vkMultiCrop',
  vkArticleCrop: 'vkArticleCrop',
  vkSiteCrop: 'vkSiteCrop',
  tmColumnCrop: 'tmColumnCrop',
  tmMultiCrop: 'tmMultiCrop',
  fbMultiCrop: 'fbMultiCrop',
  glMultiCrop: 'glMultiCrop',
  vkLinkButton: 'vkLinkButton',
  tmLinkButton: 'tmLinkButton',
  fbLinkButton: 'fbLinkButton',
  video: 'video',
  videoData: 'videoData',
  fbThumbnailImage: 'fbThumbnailImage',
  fbThumbnailImageData: 'fbThumbnailImageData',
  snippetImage: 'snippetImage',
  snippetImageData: 'snippetImageData',
  carousel: 'carousel',
  vkCarousel: 'vkCarousel',
  tmCarousel: 'tmCarousel',
  fbCarousel: 'fbCarousel',
  fbInstagramCrop: 'fbInstagramCrop',
  fbStoriesCrop: 'fbStoriesCrop',
  fbThumbnailCrop: 'fbThumbnailCrop',
  logoCrop: 'logoCrop',
  tmSmallCrop: 'tmSmallCrop',
  snippetCrop: 'snippetCrop',
  vk: 'vk',
  tm: 'tm',
  fb: 'fb',
  gl: 'gl'
}

export const defaultVkLinkButton = 'open_url'
export const defaultTmLinkButton = 'learnMore'
export const defaultFbLinkButton = 'WATCH_MORE'
